import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * cn — combine classnames with Tailwind merge dedupe.
 * Usage: cn("p-4", isActive && "bg-brand", "hover:opacity-80")
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
